"use strict";

exports.__esModule = true;
var _DeviceMetricSubscription = require("./DeviceMetricSubscription");
Object.keys(_DeviceMetricSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceMetricSubscription[key]) return;
  exports[key] = _DeviceMetricSubscription[key];
});